export const beam = () => 'BEAM';
